/**
 * API 工具对象
 * 提供 RESTful 风格的 API 调用方法
 */

import apiClient from "./apiClient";

/**
 * API 对象，提供常用的 HTTP 方法
 *
 * @example
 * // GET 请求
 * const users = await api.get('/api/v1/users');
 *
 * // POST 请求
 * const user = await api.post('/api/v1/users', { name: 'John' });
 *
 * // PUT 请求
 * await api.put('/api/v1/users/1', { name: 'Jane' });
 *
 * // DELETE 请求
 * await api.delete('/api/v1/users/1');
 */
export const api = {
  /**
   * GET 请求
   */
  get: <T>(url: string, options?: RequestInit) =>
    apiClient<T>(url, { ...options, method: "GET" }),

  /**
   * POST 请求
   */
  post: <T>(url: string, data?: unknown, options?: RequestInit) =>
    apiClient<T>(url, {
      ...options,
      method: "POST",
      body: data ? JSON.stringify(data) : undefined,
    }),

  /**
   * PUT 请求
   */
  put: <T>(url: string, data?: unknown, options?: RequestInit) =>
    apiClient<T>(url, {
      ...options,
      method: "PUT",
      body: data ? JSON.stringify(data) : undefined,
    }),

  /**
   * PATCH 请求
   */
  patch: <T>(url: string, data?: unknown, options?: RequestInit) =>
    apiClient<T>(url, {
      ...options,
      method: "PATCH",
      body: data ? JSON.stringify(data) : undefined,
    }),

  /**
   * DELETE 请求
   */
  delete: <T>(url: string, options?: RequestInit) =>
    apiClient<T>(url, { ...options, method: "DELETE" }),
};

export default api;
